import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ standalone: true, name: 'firstCase' })
export class FirstCasePipe implements PipeTransform {
  transform(value: string): string {
    return `${value[0].toUpperCase()}${value.slice(1)}`;
  }
}
